import React from 'react';
import { Route } from 'react-router';

import { ROUTES } from '../../../../core/router/routes';
import ArticleAdd from '../../../../features/article/ArticleAdd';
import ArticleEdit from '../../../../features/article/ArticleEdit';
import ArticleList from '../../../../features/article/ArticleList';

const ArticleRoute = () => [
  <Route path={ROUTES.ARTICLE.ADD} key={ROUTES.ARTICLE.ADD} component={ArticleAdd} />,
  <Route path={ROUTES.ARTICLE.EDIT} key={ROUTES.ARTICLE.EDIT} component={ArticleEdit} />,
  <Route path={ROUTES.ARTICLE.MANAGE} key={ROUTES.ARTICLE.MANAGE} component={ArticleList} />,
];

export default ArticleRoute;
